import React, { Suspense } from 'react';
import { useFeature } from '@growthbook/growthbook-react';
import { useDashboardPromoLobbyRedirect } from '../../hooks/usePromoBonusSystemRedirects';
import FEATURES from '../../constants/featureToggling';

const Main = React.lazy(() => import('./Main'));
const MainConfigurable = React.lazy(() =>
  import('../MainConfigurable/MainConfigurable')
);

const MainAsync = (props) => {
  const isCommonConfigOrdering = useFeature(
    FEATURES.ENABLE_COMMON_CONFIG_ORDERING
  ).on;

  useDashboardPromoLobbyRedirect();
  if (isCommonConfigOrdering) {
    return (
      <Suspense fallback="">
        <MainConfigurable {...props} />
      </Suspense>
    );
  }

  return (
    <Suspense fallback="">
      <Main {...props} />
    </Suspense>
  );
};

export default MainAsync;
